(function (aimi_calendar, $, app, undefined) {
  // Private object
  let __this = {};


  aimi_calendar.settingPayloadProcessor = function (requestData) {
    const calendar = {...app.calendar, ...requestData};
    return calendar;
  }

  aimi_calendar.settingSaveCallBack = function (response) {
    app.notifyEl.update({'message': response.message, progress: 90});

  }

  const renderCampaignView = function ($container, response) {
    $container.empty();
    // Group the objects by the 'name' key
    const groupedData = response.campaignLirary;

    let $__template = app.templates['calender__campaign-views'],
        template = _.template($__template);

    let campaignsData = [];
    let customAndArticlesData = [];
    _.each(groupedData, function (posts, campaignId) {
      if (!_.isUndefined(posts[0].app_campaign_name)) {
        campaignsData.push(
            {
              name: posts[0].app_campaign_name,
              id: campaignId
            }
        );
      } else {
        campaignsData.push(
            {
              name: 'Article',
              id: 'articlePosts'
            }
        );
        campaignsData.push(
            {
              name: 'Custom Posts',
              id: 'customPosts'
            }
        );
      }
    });

    let $template = $(
        template({campaigns: campaignsData})
    );
    $container.append($template);

    // Add posts to card
    _.each(groupedData, function (posts, campaignId) {

      let $table = $(`#campaign-table-${campaignId} .card-body`);
      let $tableArticles = $(`#campaign-table-articlePosts .card-body`);
      let $tableCustomPosts = $(`#campaign-table-customPosts .card-body`);


      _.each(posts, function (event, index) {
        if (typeof event.deleted == 'undefined') {
          // hide card footer
          event.cardFooter = true;
          event.swapButton = false;
          event.showMaximize = true;
          const $post = PostsList.prepareRow(app, event, 'calender__library-table-row');
          if (event.segments === 'custom') {
            $post.appendTo($tableCustomPosts);
          }
          if (event.segments === 'article') {
            $post.appendTo($tableArticles);
          } else {
            $post.appendTo($table);
          }
        }
      });

    });

    new SimpleBar($('.tab-scrollable-area', $container)[0], {autoHide: true});
    observerCampaignView();
  }

  aimi_calendar.refresh = async function (calendarId, posts = null) {

    const $postsContainer = $('[data-posts-container]');
    const $postsContainerCampaignView = $('[data-posts-container-campaign-view]');

    $('[data-calendar-action]').attr('disabled', 'disabled');
    __this.calendar = initCalendar(app);

    if(posts === null) {
      Responsive.getCalendarColumn($postsContainer, $postsContainer);
      __this.listMananger = new PostsList(app, {calendarId: calendarId}, $postsContainer, 'calender__library-card', false);

      __this.observerManager = new ImageObserverManager(app, '.posts-grid-item', 'calendar-card-width', $postsContainer);

      // To observe resizing for an element
      __this.observerManager.observeResize($postsContainer[0]);

    } else {
     __this.listMananger.renderListByData({posts : posts});
    }

    __this.listMananger.onRenderList().then(function (response) {
      $('[data-calendar-action]').removeAttr('disabled');
      __this.calendar.addEventSource(response.calendarEvents);
      renderCampaignView($postsContainerCampaignView, response);
      navigateToToday();
    });

    app.calendarListManager = __this.listMananger;

    return __this.listMananger;
  }

  // Initialize Calendar.
  aimi_calendar.init = async function (calendarId) {

    __this.listMananger = await aimi_calendar.refresh(calendarId);

    //  If app.calendar is empty
    if (app.isEmpty(app.calendar)) {
      await app.apis['calendar'].fetch();

      // If build next month
      if (app.calendar.next_month === "1") {
        const page = _.template(app.templates['calender__next-month']);
        const $modal = app.infoModal('Build Calendar', page({id : app.calendar.id}), {dialogClass : 'modal-dialog-scrollable modal-lg'});
        app.buildNewMonthModal = $modal;
      }
    }


    new SimpleBar(document.getElementById('tab_block_1'), {autoHide: true});

    $(document).on("shown.bs.tab", ".todoapp-wrap .hk-pg-header [data-bs-toggle='tab']", function (e) {
      const $activeNav = $(this);

      __this.activeTab = $activeNav.attr('href');
      __this.$acitveTabContent = $(`${__this.activeTab}`);
      if (__this.activeTab === '#tab_block_3') {

      }

      if (__this.activeTab === '#tab_block_2') {
        __this.calendar.render();
      }
    });
  };

  aimi_calendar.approvePayloadProcessor = function (requestData) {
    const reason = requestData.notes;
    let posts = [];
    _.each(window.postsSeekingApproval, function (post, postId) {
      if (post.actionStatus !== 'approved&scheduled' && post.actionStatus !== 'approved') {
        posts.push({id: postId, reason: reason, status : post.actionStatus});
      }
    })
    return posts;
  };


  aimi_calendar.reviewPayloadProcessor = function (requestData) {
    const reason = requestData.notes;
    let posts = [];
    _.each(window.postsSeekingApproval, function (post, postId) {
      posts.push({id: postId, reason: reason, status : post.actionStatus});
    })
    return posts;
  };

  aimi_calendar.approveSaveCallback = function (response) {
    app.unApproveModal.modal('hide');
    app.notifyEl.update({'message': response.message, progress: 90});
  };

  aimi_calendar.setting = {
    init: async function () {
      const self = this;

      const $container = $('[data-calendar-setting]');

      const calendarSetting = new Calendar(app);
      calendarSetting.renderInSide($container).then(async function () {

        await app.apis['calendar'].fetch();

        self.setValues($container);
        removePlaceholderLoader();
      });


      const removePlaceholderLoader = () => {
        Utils.getTabContent('#tab_block_1').find('.placeholder-loader').removeClass('placeholder');
      }

      app.initSimpleBar(document.getElementById('tab_block_1'));
    },

    setValues: function ($container) {
      const calendar = app.calendar;

      __this.$form = $('form[name=aimi-calendar-setting]');
      __this.$isDefault = $(':input[name=is_default]', __this.$form);
      __this.$name = $(':input[name=name]', __this.$form);
      __this.$businessProfile = $(':input[name=persona_id]', __this.$form);
      __this.$autoBuildDay = $(':input[name=autoBuildDay]', __this.$form);
      __this.$autoBuild = $(':input[name=autobuild]', __this.$form);
      __this.$customPosts = $(':input[name=custom_posts]', __this.$form);


      if (!app.isEmpty(parseInt(calendar.is_default))) {
        __this.$isDefault.prop('checked', true);
      }

      if (!app.isEmpty(parseInt(calendar.autobuild))) {
        Utils.setSwitchVal(__this.$autoBuild, true, true);
      }

      if (!app.isEmpty(parseInt(calendar.custom_posts))) {
        Utils.setSwitchVal(__this.$customPosts, true, true);
      }

      __this.$name.val(calendar.name);
      __this.$businessProfile.val(calendar.persona_id).trigger('change');
      __this.$autoBuildDay.val(calendar.autoBuildDay).trigger('change');

    }
  }

  const navigateToToday = () => {
    const $calendarTodayButton =  $('.fc-today-button');
    if($calendarTodayButton.length) {
      $calendarTodayButton.trigger('click');
    }

    const todayPost = Utils.findClosestDateToToday(_.values(window.calendarPosts));
    if(todayPost) {
      const elements = document.querySelectorAll(`.view-post[data-id="${todayPost.id}"]`)
      if(elements.length) {
        elements.forEach(function (element){
          element.scrollIntoView({behaviour: 'smooth', block: 'center'});
        })
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {

    $(document).on("click.calendar-actions", "[data-calendar-action]", async function (e) {
      const app = PreBuilt;

      const $this = $(this);
      const action = $this.attr('data-calendar-action');

      if (action === 'new-calendar') {
        const businessProfileId = $(this).data('business-profile-id');
        const newCalendar = new Calendar(app);
        newCalendar.render({'business_profile': businessProfileId});
      }

      if (action === 'new-month') {
        const calendarId = $this.data('calendar-id');
        app.doButtonAction($this);
        const buildNewMonth = await app.apis['calendar']['buildNextMonth'](calendarId);
        app.doButtonReset($this);
        app.buildNewMonthModal.modal('hide');
        aimi_calendar.refresh(calendarId).then(function (listManager) {
          listManager.onRenderList().then(function () {

          })
        });
      }

      if (action === 'cancel-new-month') {
        const calendarId = $this.data('calendar-id');
        app.doButtonAction($this);
        const buildNewMonth = await app.apis['calendar']['noBuild'](calendarId);
        app.doButtonReset($this);
        app.buildNewMonthModal.modal('hide');
        aimi_calendar.refresh(calendarId).then(function (listManager) {
          listManager.onRenderList().then(function () {

          })
        });
      }

      if (action === 'build-more') {
        const newCalendar = new Calendar(app);
        newCalendar.buildMore();
      }

      if (action === 'refresh') {
        app.button($this, 'loading');
        aimi_calendar.refresh(app.calendarId).then(function (listManager) {
          listManager.onRenderList().then(function () {
            app.button($this, 'reset');
          })
        });
      }
      if (action === 'today') {
        app.button($this, 'loading');
        navigateToToday();
        app.button($this, 'reset');
      }

      if (action === 'filter') {
        const newCalendar = new Calendar(app);
        newCalendar.filter();
      }


      if (action === 'custom-post') {
        new CustomPost(app);
      }

      const clearAndRebuildMessage = 'Are you sure you want to rebuild this calendar? All scheduled or unscheduled posts will be replaced.';
      const rebuildUnscheduledMessage = 'Are you sure you want to rebuild this calendar? All unscheduled posts will be replaced.';
      const updatePostsMessage = 'Are you sure you want to update all your posts? All your posts will be updated with your changes.';

      if (action === 'update-posts') {
        app.confirm('Update Posts', updatePostsMessage).then(function (response) {
          const $button = response.button;
          const confirm = response.confirm;
          const $modal = response.modal;

          // If the user confirms the deletion, proceed with the delete operation.
          if (confirm === true) {
            app.doButtonAction($button);
            const responsePosts = app.apis['calendar'].rebuild(app.calendarId, true, true).then(function () {
              app.doButtonReset($button);
              app.hideModal($modal);
              aimi_calendar.refresh(app.calendarId);
            });
          }
        })
      }

      if (action === 'rebuild-unscheduled') {
        app.confirm('Rebuild Unscheduled', rebuildUnscheduledMessage).then(function (response) {
          const $button = response.button;
          const confirm = response.confirm;
          const $modal = response.modal;

          // If the user confirms the deletion, proceed with the delete operation.
          if (confirm === true) {
            app.doButtonAction($button);
            const responsePosts = app.apis['calendar'].rebuild(app.calendarId, false, true).then(function () {
              app.doButtonReset($button);
              app.hideModal($modal);
              aimi_calendar.refresh(app.calendarId);
            });
          }
        })
      }
      if (action === 'clear-and-rebuild') {
        app.confirm('Clear & Rebuild', clearAndRebuildMessage).then(function (response) {
          const $button = response.button;
          const confirm = response.confirm;
          const $modal = response.modal;

          // If the user confirms the deletion, proceed with the delete operation.
          if (confirm === true) {
            app.doButtonAction($button);
            const responsePosts = app.apis['calendar'].rebuild(app.calendarId, false, false).then(function () {
              app.doButtonReset($button);
              app.hideModal($modal);
              aimi_calendar.refresh(app.calendarId);
            });
          }
        })

      }

      if (action === 'schedule-all') {
        app.doButtonAction($this);
        aimi_social_profiles.checkSocial().then(function (connectionOk) {
          app.doButtonReset($this);
          if (connectionOk) {
            app.confirm('Schedule all posts?', 'Are you sure you want to schedule all posts for this calendar?').then(function (response) {
              const $button = response.button;
              const confirm = response.confirm;
              const $modal = response.modal;

              // If the user confirms the deletion, proceed with the delete operation.
              if (confirm === true) {
                app.doButtonAction($button);
                let posts = [];
                _.each(window.calendarPosts, function (post, postId) {
                  if (post.actionStatus === 'unscheduled') {
                    posts.push({id: postId, plan: post.plan});
                  }
                })
                const responsePosts = app.apis['calendar'].scheduleAll(app.calendarId, posts).then(function () {
                  app.doButtonReset($button);
                  app.hideModal($modal);
                  aimi_calendar.refresh(app.calendarId);
                });
              }

            })
          }
        });
      }

      if (action === 'unschedule-all') {
        app.confirm('Unschedule all posts?', 'Are you sure you want to unschedule all posts for this calendar?').then(function (response) {
          const $button = response.button;
          const confirm = response.confirm;
          const $modal = response.modal;

          // If the user confirms the deletion, proceed with the delete operation.
          if (confirm === true) {
            app.doButtonAction($button);
            let posts = [];
            _.each(window.calendarPosts, function (post, postId) {
              if (post.actionStatus === 'scheduled') {
                posts.push(postId);
              }
            })
            const responsePosts = app.apis['calendar'].unScheduleAll(app.calendarId, posts).then(function () {
              app.doButtonReset($button);
              app.hideModal($modal);
              aimi_calendar.refresh(app.calendarId);
            });
          }
        })
      }

      if (action === 'approve-all') {
        app.confirm('Approve all posts?', 'Are you sure you want to approve all posts for this calendar?').then(function (response) {
          const $button = response.button;
          const confirm = response.confirm;
          const $modal = response.modal;

          // If the user confirms the deletion, proceed with the delete operation.
          if (confirm === true) {
            app.doButtonAction($button);
            let posts = [];
            _.each(window.calendarPosts, function (post, postId) {
              if (post.actionStatus !== 'approved&scheduled' && post.actionStatus !== 'approved') {
                posts.push({id: postId, reason: '', status : post.actionStatus});
              }
            })

            const responsePosts = app.apis['calendar'].approvePosts('approve', null, posts).then(function () {
              app.doButtonReset($button);
              app.hideModal($modal);
              aimi_calendar.refresh(app.calendarId);
            });
          }

        })
      }

      if (action === 'unapprove-all') {
        window.postsSeekingApproval = window.calendarPosts;
        app.inputPrompt({
          type: 'textarea',
          val: '',
          title: 'Why the posts are not approved?',
          saveButtonText: 'Submit Reason',
          inputLabel: 'Reason',
          inputName: 'notes',
          placeHolder: 'Please type details of the changes or issues with the post',
          payloadProcessor: 'aimi_calendar.approvePayloadProcessor',
          saveApi: 'calendar.unApprovePostsSave',
          saveApiCallBack: 'aimi_calendar.approveSaveCallback'
        }).then(function ($modal) {
          app.unApproveModal = $modal
        });

      }
    });

  });
}(window.aimi_calendar = window.aimi_calendar || {}, jQuery, PreBuilt));
